import dynaForms from '@elab/core/utils/dynaForms';

export const storeName = 'resetPassword';

export default {
    ...dynaForms.getTypes(storeName),
};
